import { css } from 'styled-components';
import { spacing } from '../../atoms/spacing/spacing';
import { colors } from '../../atoms/colors/colors';
import { ButtonTags } from './class-name-tags';
import { complementaryColors } from '../../atoms/colors/complementary-colors';
export const commonTheme = {
    base: css `
    border: solid 1px;
    border-radius: 6px;
    outline-offset: 3px;

    line-height: 1.625rem;
    padding: ${spacing.spacing4} ${spacing.spacing16};

    & .${ButtonTags.iconWrapper} svg {
      fill: currentColor;
    }

    &.action {
      &.start-icon {
        padding-left: ${spacing.spacing8};
      }
      &.end-icon {
        padding-right: ${spacing.spacing8};
      }
    }

    &.icon {
      padding: ${spacing.spacing8};
    }
  `,
    primary: '',
    secondary: '',
    ghost: css `
    border-color: transparent;
    background-color: transparent;
  `,
    negative: css `
    background-color: ${colors.red600};
    border-color: ${colors.red600};
    color: white;

    &:hover {
      background-color: ${colors.red500};
      border-color: ${colors.red500};
    }

    &.disabled {
      background-color: ${complementaryColors.strawberry700};
      border-color: ${complementaryColors.strawberry700};
    }

    &:active:not(.disabled) {
      background-color: ${colors.red700};
      border-color: ${colors.red700};
    }
  `,
    text: css `
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;

    &.compact {
      padding: 0;
    }

    &.disabled {
      cursor: default;
    }

    &.action {
      padding: 0;
    }
  `,
    compact: css `
    padding: 0 ${spacing.spacing8};

    &.icon {
      padding: ${spacing.spacing2};
    }
  `,
};
//# sourceMappingURL=common-theme.js.map